// https://github.com/darkskyapp/sphere-knn
import sphereKnn from 'sphere-knn';

/**
 * This is the type that we're going to be using. The rest is just additional
 * stuff that sphere-knn provides.
 */
interface HasLongitudeAndLatitude {
    longitude: number;
    latitude: number;
}

interface HasLonLat {
    lon: number;
    lat: number;
}

/**
 * The internal implementation can take a variety of ways to specify latitude and longitude.
 * Note that the array types use arg0 for latitude and arg1 for longitude
 */
export class LocationLookup<T extends HasLongitudeAndLatitude | HasLonLat> {
    _sphereKnn: (lat: number, lon: number, maxResults: number, maxDistance: number) => any;

    constructor(locationList: Array<T>) {
        this._sphereKnn = sphereKnn(locationList);
    }

    // Lookup will return any value stored, as long as it matches the interface Location
    // Only returns the data field in LocationLookupItem
    lookup(lat: number, lon: number, maxResults: number = 1, maxDistance: number = Infinity): T[] {
        return this._sphereKnn(lat, lon, maxResults, maxDistance);
    }
}
